import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { AVAILABLE_FOR_LABELS, COMM_LABELS } from "@/lib/api";

/**
 * "Available For" card plus preferred contact methods and the privacy note.
 *
 * Extracted verbatim from src/pages/SponsorProfile.jsx during the code-quality
 * pass: markup, copy, data-testids and behaviour are unchanged.
 */
export default function SponsorAvailabilityCard({ sponsor }) {
  return (
    <div className="sm-card p-6 bg-white">
      <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Available For</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {(sponsor.available_for || []).length === 0 ? (
          <p className="text-sm text-[#4B5A60]">Not specified.</p>
        ) : (
          sponsor.available_for.map((a) => (
            <span
              key={a}
              className="px-3 py-1.5 rounded-full bg-[#F2EFE8] border border-[#E3DED4] text-sm text-[#1F2A2E]"
            >
              {AVAILABLE_FOR_LABELS[a] || a}
            </span>
          ))
        )}
      </div>
      <h3 className="mt-5 text-sm font-bold uppercase tracking-wide text-[#4B5A60]">
        Preferred contact methods
      </h3>
      <div className="mt-2 flex flex-wrap gap-2">
        {(sponsor.communication_methods || []).map((m) => (
          <span
            key={m}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#D7EEF0] text-sm font-semibold text-[#1F6F78]"
          >
            {m === "phone" ? (
              <Phone className="w-3.5 h-3.5" />
            ) : (
              <MessageCircle className="w-3.5 h-3.5" />
            )}
            {COMM_LABELS[m] || m}
          </span>
        ))}
      </div>
      <p className="mt-3 text-xs text-[#7A868B]">
        For everyone&apos;s privacy, phone numbers are never shown publicly. Members share contact
        details privately only if they choose to.
      </p>
    </div>
  );
}
